// Countries data with prioritized order (GCC + Pakistan)
export const Countries = [
  {
    name: "Kuwait",
    dial_code: "+965",
    code: "KW",
    flag: "/images/flag/Kuwait.png",
  },
  {
    name: "Saudi Arabia",
    dial_code: "+966",
    code: "SA",
    flag: "/images/flag/Saudi.png",
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    code: "PK",
    flag: "/images/flag/Pakistan.png",
  },
  {
    name: "Bahrain",
    dial_code: "+973",
    code: "BH",
    flag: "/images/flag/Bahrain.png",
  },
  {
    name: "Qatar",
    dial_code: "+974",
    code: "QA",
    flag: "/images/flag/Qatar.png",
  },
  {
    name: "UAE",
    dial_code: "+971",
    code: "AE",
    flag: "/images/flag/Uae.png",
  },
  {
    name: "Oman",
    dial_code: "+968",
    code: "OM",
    flag: "/images/flag/Oman.png",
  },
];

// National-number patterns by dial code (no + / country code in the input)
export const phonePatterns = {
  // Kuwait: 8 digits, starts with 4, 5, 6, or 9
  "965": /^[4569]\d{7}$/,
  // Saudi Arabia: 9 digits, starts with 5
  "966": /^5\d{8}$/,
  // UAE: 9 digits, starts with 50, 52, 54, 55, 56, or 58
  "971": /^5[024568]\d{7}$/,
  // Qatar: 8 digits, starts with 3, 5, 6, or 7
  "974": /^[3567]\d{7}$/,
  // Bahrain: 8 digits, starts with 3 or 6 (mobile)
  "973": /^[36]\d{7}$/,
  // Oman: 8 digits, starts with 7 or 9
  "968": /^[79]\d{7}$/,
  // Pakistan: 10 digits, starts with 3
  "92": /^3\d{9}$/,
};

export const countryCodeToDialCode = {
  KW: "965",
  SA: "966",
  PK: "92",
  BH: "973",
  QA: "974",
  AE: "971",
  OM: "968",
};

export const getMaxDigits = (countryCode) => {
  const dialCode = countryCodeToDialCode[countryCode] || "965";
  switch (dialCode) {
    case "92": // Pakistan — 10 digits total
      return 10;
    case "965": // Kuwait — 8 digits total
      return 8;
    case "966": // Saudi Arabia — 9 digits total
      return 9;
    case "973": // Bahrain — 8 digits total
      return 8;
    case "974": // Qatar — 8 digits total
      return 8;
    case "971": // UAE — 9 digits total
      return 9;
    case "968": // Oman — 8 digits total
      return 8;
    default:
      return 10;
  }
};

// Live typing: empty stays valid; submit still requires a non-empty valid number
export const validatePhoneNumber = (phoneNumber, countryCode) => {
  if (!phoneNumber || phoneNumber.length === 0) {
    return { isValid: true, error: "" };
  }

  const dialCode = countryCodeToDialCode[countryCode] || "965";
  const regex = phonePatterns[dialCode];

  if (!regex) {
    return { isValid: true, error: "" };
  }

  const cleanPhone = phoneNumber.replace(/[\s\-\(\)]/g, "");

  if (!regex.test(cleanPhone)) {
    const country = Countries.find((c) => c.code === countryCode);
    return {
      isValid: false,
      error: `Invalid ${country?.name || countryCode} phone number format`,
    };
  }

  return { isValid: true, error: "" };
};

export const getMaskPattern = (countryCode) => {
  const dialCode = countryCodeToDialCode[countryCode] || "965";
  switch (dialCode) {
    case "92": // Pakistan — 10 digits
      return "9999999999";
    case "965": // Kuwait — 8 digits
      return "99999999";
    case "966": // Saudi Arabia — 9 digits
      return "999999999";
    case "973": // Bahrain — 8 digits
      return "99999999";
    case "974": // Qatar — 8 digits
      return "99999999";
    case "971": // UAE — 9 digits
      return "999999999";
    case "968": // Oman — 8 digits
      return "99999999";
    default:
      return "9999999999";
  }
};
